import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=a03773aa&scoped=true"
import script from "./MobileNavigation.js?vue&type=script&lang=js&external"
export * from "./MobileNavigation.js?vue&type=script&lang=js&external"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&id=a03773aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03773aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
